__turbopack_context__.v({
  "alternative": "OnboardingModal-module__2w9BJG__alternative",
  "alternatives": "OnboardingModal-module__2w9BJG__alternatives",
  "alternativesLabel": "OnboardingModal-module__2w9BJG__alternativesLabel",
  "alternativesStrip": "OnboardingModal-module__2w9BJG__alternativesStrip",
  "colorFieldGroup": "OnboardingModal-module__2w9BJG__colorFieldGroup",
  "colorFields": "OnboardingModal-module__2w9BJG__colorFields",
  "colors": "OnboardingModal-module__2w9BJG__colors",
  "colorsHint": "OnboardingModal-module__2w9BJG__colorsHint",
  "fields": "OnboardingModal-module__2w9BJG__fields",
  "footerSpacer": "OnboardingModal-module__2w9BJG__footerSpacer",
  "header": "OnboardingModal-module__2w9BJG__header",
  "hiddenInput": "OnboardingModal-module__2w9BJG__hiddenInput",
  "intro": "OnboardingModal-module__2w9BJG__intro",
  "logoEmpty": "OnboardingModal-module__2w9BJG__logoEmpty",
  "logoPreview": "OnboardingModal-module__2w9BJG__logoPreview",
  "logoRow": "OnboardingModal-module__2w9BJG__logoRow",
  "paletteChip": "OnboardingModal-module__2w9BJG__paletteChip",
  "paletteStrip": "OnboardingModal-module__2w9BJG__paletteStrip",
  "paletteSwatch": "OnboardingModal-module__2w9BJG__paletteSwatch",
  "stepper": "OnboardingModal-module__2w9BJG__stepper",
  "uploadLabel": "OnboardingModal-module__2w9BJG__uploadLabel",
});
